import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import ColorTokensProvider from './ColorTokensProvider';
import {
  colorTokens as defaultColorTokens,
  default as defaultTheme,
} from '../themes/default';
import {
  colorTokens as publicisColorTokens,
  default as publicisTheme,
} from '../themes/publicis';
import { ColorTokens } from '../types';

import { ThemeName, useThemeName } from '@/features/users';

interface CustomThemeProvider {
  children: React.ReactNode;
}

const themes: Record<
  ThemeName,
  {
    theme: typeof defaultTheme;
    colorTokens: ColorTokens;
  }
> = {
  default: {
    theme: defaultTheme,
    colorTokens: defaultColorTokens,
  },
  publicis: {
    theme: publicisTheme,
    colorTokens: publicisColorTokens,
  },
};

const ThemeProvider = ({ children }: CustomThemeProvider) => {
  const { themeName } = useThemeName();

  return (
    <MuiThemeProvider theme={themes[themeName].theme}>
      <ColorTokensProvider colorTokens={themes[themeName].colorTokens}>
        {children}
      </ColorTokensProvider>
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
